import { UI_ORDER_TYPES_LIST } from '@drift/common';

export const BLUR_OVERLAY_SIBLING_CLASSES = 'relative z-10'; // Styles to be applied to the sibling (the trade form content being blocked) of the PreLaunchMarketContentBlock

export const PERP_ORDER_TYPE_OPTIONS = UI_ORDER_TYPES_LIST.filter(
	(orderType) => orderType.value !== 'oracle'
);

export const SPOT_ORDER_TYPE_OPTIONS = UI_ORDER_TYPES_LIST.filter(
	(orderType) =>
		orderType.value !== 'oracle' && orderType.value !== 'scaledOrders'
);

export const PRICE_FALLBACK_DISPLAY_VALUE = 'None';
